import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationCheckList, updateStationCheck } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunStationCheckUpdate',
  components: {},
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      title: '',
      tankList: [],
      formData: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res, resTank;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.title = _this.$route.params.meta.title;
              _context2.next = 3;
              return getStationCheckList({
                'dailyNo': _this.$route.params.dailyNo,
                'dataType': 'sequence',
                'page': 1,
                'pageSize': 999999
              });

            case 3:
              res = _context2.sent;
              _this.formData = _this2.initData();
              _this.formData.stationId = res.data.list[0].stationId;
              _this.formData.dailyDate = res.data.list[0].dailyDate + '';
              _this.formData.rows = res.data.list;
              _context2.next = 10;
              return getStationOilTankInfoList({
                stationId: _this2.formData.stationId,
                page: 1,
                pageSize: 999999,
                dataType: 'simpleFields'
              });

            case 10:
              resTank = _context2.sent;
              resTank.data.list.forEach(function (item) {
                _this2.tankList.push({
                  'oilTankNo': item.oilTankNo,
                  'tankNum': item.tankNum,
                  'oilCode': item.oilCode,
                  'tankHeightStatus': item.tankHeightStatus
                });
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    initData: function initData() {
      return {
        stationId: '',
        dailyDate: '',
        rows: []
      };
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onClear: function onClear() {
      this.formData.rows = [];
    },
    onAddRow: function onAddRow() {
      var _this3 = this;

      var isAddAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.formData.rows.length === this.tankList.length) {
        return;
      }

      var oilTankNoArr = this.formData.rows.map(function (item) {
        return item.oilTankNo;
      });
      var canAddTankList = this.tankList.filter(function (item) {
        return !oilTankNoArr.includes(item.oilTankNo);
      });

      if (canAddTankList.length) {
        if (isAddAll === true) {
          canAddTankList.forEach(function (item) {
            _this3.formData.rows.push({
              'oilTankNo': item.oilTankNo,
              'tankNum': item.tankNum,
              'oilCode': item.oilCode,
              'tankHeightStatus': item.tankHeightStatus,
              'tankAdjustLiters': '',
              sequenceOilHeight: '',
              sequenceWaterHeight: '',
              sequenceWaterCapacity: '',
              sequenceOilCapacity: '',
              measureOilHeight: '',
              measureWaterHeight: '',
              measureWaterCapacity: '',
              measureOilCapacity: ''
            });
          });
        } else {
          this.formData.rows.push({
            'oilTankNo': canAddTankList[0].oilTankNo,
            'tankNum': canAddTankList[0].tankNum,
            'oilCode': canAddTankList[0].oilCode,
            'tankHeightStatus': canAddTankList[0].tankHeightStatus,
            'tankAdjustLiters': '',
            sequenceOilHeight: '',
            sequenceWaterHeight: '',
            sequenceWaterCapacity: '',
            sequenceOilCapacity: '',
            measureOilHeight: '',
            measureWaterHeight: '',
            measureWaterCapacity: '',
            measureOilCapacity: ''
          });
        }
      }
    },
    onDelRow: function onDelRow(index) {
      this.formData.rows.splice(index, 1);
    },
    onSave: function onSave() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.formData.stationId) {
                  _context3.next = 3;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '油站不能为空！'
                });

                return _context3.abrupt("return");

              case 3:
                if (_this4.formData.dailyDate) {
                  _context3.next = 6;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '日期不能为空！'
                });

                return _context3.abrupt("return");

              case 6:
                _this4.formData.rows.forEach(function (item) {
                  item.dailyDate = Number(_this4.formData.dailyDate);
                });

                _context3.next = 9;
                return updateStationCheck({
                  'stationId': _this4.formData.stationId,
                  'sequenceList': _this4.formData.rows
                });

              case 9:
                res = _context3.sent;

                if (res.code == 0) {
                  _this4.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  setTimeout(function () {
                    _this4.goBack();
                  }, 300);
                }

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};